import React from 'react';

import { useBiopharmaGroupsState } from './BiopharmaGroupsContext';

import Table from '../../Shared/UI/Table/components/Table';
import Thead from '../../Shared/UI/Table/components/Thead';
import Tbody from '../../Shared/UI/Table/components/Tbody';
import Tr from '../../Shared/UI/Table/components/Tr';
import Th from '../../Shared/UI/Table/components/Th';
import Td from '../../Shared/UI/Table/components/Td';

const BiopharmaGroupsTable = () => {
  const biopharmaGroupsState = useBiopharmaGroupsState();

  return (
    <Table>
      <Thead>
        <Tr>
          <Th>Name</Th>
          <Th>Weblinks</Th>
          <Th>Locations</Th>
          <Th>Categories</Th>
        </Tr>
      </Thead>
      <Tbody>
        {biopharmaGroupsState?.biopharmaGroups?.map(biopharmaGroup => (
          <Tr key={biopharmaGroup.id}>
            <Td>
              <a href={`/biopharma_groups/${biopharmaGroup.id}`}>{biopharmaGroup.name}</a>
            </Td>
            <Td>
              {biopharmaGroup.weblinks.map((weblink) => (
                <a key={weblink.url} href={weblink.url} target="_blank" rel="noopener noreferrer">{weblink.url}</a>
              ))}
            </Td>
            <Td>
              {biopharmaGroup.locations.map((location) => (
                <p key={`${location.municipality}-${location.state}`}>{`${location.municipality}, ${location.state} ${location.country}`}</p>
              ))}
            </Td>
            <Td>
              {biopharmaGroup.categories.map((category) => (
                <p key={category.name}>{category.name}</p>
              ))}
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default BiopharmaGroupsTable;
